exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-wrap .setting-item {\n  cursor: pointer;\n}\n.nav-wrap .desc {\n  line-height: 25px;\n  margin-top: 10px;\n}\n.nav-wrap .section-body .el-form-item__content {\n  margin-left: 50px;\n}\n.nav-wrap .setting-remove {\n  padding: 0 5px;\n}\n.nav-wrap .goods-title {\n  padding: 0 10px;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1381d863","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pc/custompage/components/plugins/nav/style.vue
// module id = 1235
// module chunks = 0